import { Currency } from '@seapoint/server/enums';
import { getCurrencySymbol } from './get-currency-symbol';

export const getMinPaymentAmountErrorMessage = (currency?: Currency) => {
  const currencySymbol = getCurrencySymbol(currency ?? '');
  return `Enter an amount greater than ${currencySymbol}0.00`;
};
